import React from "react";
import PropTypes from "prop-types";

/**
 * @param {Object} props
 * @param {boolean} props.blurred
 * @returns {Element}
 * @constructor
 */
export default function HeaderText({ blurred }) {
  return (<div className={blurred ? "blurred" : ""}>
    <p>
      The Federal Risk and Authorization Management Program (FedRAMP)
      is a government-wide program that provides a standardized approach to
      security assessment, authorization, and continuous monitoring for cloud products and services.
    </p>
    <p>
      <a href="https://www.fedramp.gov/" target="_blank">https://www.fedramp.gov/</a>
    </p>
    <strong>Disclaimer:</strong>
    The listing below is for general information – it is not updated in “real-time”. It should be viewed as an
    overview to provide guidance on SEWP products identified as FedRAMP compliant. Please use the QRT tool and
    indicate which products need to be FedRAMP certified in your attachments and/or enter the requirements in the
    Summary text box.
    <br/><br/>
  </div>);
}

HeaderText.propTypes = {
  blurred: PropTypes.bool.isRequired,
};